module.exports = __webpack_public_path__ + "static/media/ic-ticket.41ca7ef6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-ticket.svg
// module id = 675
// module chunks = 14